import { BaseProxy, type ProxyMethods } from '@/proxies/Proxy'

export default class BasePriceProxy extends BaseProxy implements ProxyMethods {
  public endpoint = 'prices/base'

  update(id: string | number, item: object) {
    return this.submit('put', `/${this.endpoint}`, item)
  }
}
